var map = {
	"./de_DE.json": 481,
	"./en_AU.json": 482,
	"./en_CA.json": 483,
	"./en_GB.json": 484,
	"./es_AR.json": 485,
	"./es_ES.json": 486,
	"./es_MX.json": 487,
	"./fr_CA.json": 488,
	"./fr_FR.json": 489,
	"./it_IT.json": 490,
	"./nl_NL.json": 491,
	"./pt_BR.json": 492,
	"./pt_PT.json": 493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;